import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProgramsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProgramDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProgramDocumentSortInput> | Types.ProgramDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProgramsQuery = { __typename?: 'Query', programs?: { __typename?: 'ProgramsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProgramDocument', tenantId: string, program: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetProgramsDocument = new TypedDocumentString(`
    query GetPrograms($where: ProgramDocumentFilterInput, $order: [ProgramDocumentSortInput!], $first: Int, $after: String) {
  programs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      tenantId
      program
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPrograms: build.query<GetProgramsQuery, GetProgramsQueryVariables | void>({
      query: (variables) => ({ document: GetProgramsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProgramsQuery, useLazyGetProgramsQuery } = injectedRtkApi;
